import { IonGrid, IonRow, IonCol, IonSpinner } from '@ionic/react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import {
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tab,
  Tabs,
  Typography,
} from '@material-ui/core';
import { isMobile } from 'react-device-detect';
import './Home.scss';
import { RootState } from '../../models/RootState';
import HomeView from '../../constants/HomeView';
import Footer from '../Footer/Footer';
import Banner from './Banner';
import { connect } from 'react-redux';
import Slider from 'react-slick';
import { casinoGameSelected, setDcGameUrl } from '../../store';
import Modal from '../Modal/Modal';
import LoginForm from '../LoginForm/LoginForm';
import { ALLOW_CASINO } from '../../constants/CasinoPermission';
import { DcGameNew } from '../../models/dc/DcGame';
import { AxiosResponse } from 'axios';
import SVLS_API from '../../svls-api';
import GPAY from '../../assets/images/icons/GPAY.svg';
import PAYTM from '../../assets/images/icons/PAYTM.svg';
import PhonePe from '../../assets/images/icons/PhonePe.svg';
import BankTransfer from '../../assets/images/icons/BankTransfer.svg';
import UPI from '../../assets/images/icons/UPI.svg';
import { ShowPaymentMethods } from '../../constants/WhitelabelConfig';
import { BRAND_NAME } from '../../constants/Branding';
import SEO from '../SEO/Seo';
import { DomainConfig } from '../../models/DomainConfig';
import { redirectGame } from '../../store/common/commonActions';
import SportsBook from './SportsBook';
import CasinoProvidersSlider from './CasinoProvidersSlider';
import GameCardsList from './GameCardsList';
import LiveGamesCardList from './LiveGamesCardList';
import { useDomainConfigHook } from '../../hooks/domainConfigHook';
import { checkForDomainConfig } from '../../util/domainConfigUtils';
import { CONFIG_PERMISSIONS } from '../../constants/ConfigPermission';

const Headings = HomeView.HOME_PAGE_HEADERS;
const Images = HomeView.HOME_PAGE_IMAGES;
const LiveGames = [
  Images.andhar_bahar,
  Images.cards_32,
  Images.baccarat_fast,
  Images.roulette,
  Images.teen_patti,
  Images.roulette_thunder,
  Images.vip_roulette,
  Images.dream_catcher,
];

const HomePageGames = HomeView.HOME_PAGE_GAMES;
const CasinoProviders = HomeView.HOME_PAGE_CASINO_TILES;

type StoreProps = {
  casinoGameSelected: (game: { id: string; name: string }) => void;
  setDcGameUrl: (url: string) => void;
  loggedIn: boolean;
  allowedConfig: number;
  domainConfig: DomainConfig;
};

const Home: React.FC<StoreProps> = (props) => {
  const { loggedIn, allowedConfig, domainConfig } = props;

  const { showCasinoComponents, showSportsComponents } = useDomainConfigHook();

  const [games, setGames] = useState<DcGameNew[]>([]);
  const [liveGames, setLiveGames] = useState<DcGameNew[]>([]);
  const [virtualGames, setVirtualGames] = useState<DcGameNew[]>([]);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [modalTitle] = useState('Login');
  const [redirectUrl] = useState<string>('');
  const [showDialog, setShowDialog] = useState<boolean>(false);
  const [trendingGames, setTrendingGames] = useState<DcGameNew[]>([]);
  const [royalGames, setRoyalGames] = useState<DcGameNew[]>([]);
  const pathLocation = useLocation();

  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: isMobile ? 4 : 10,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 500,
    pauseOnHover: true,
  };

  const providerSettings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: isMobile ? 4 : 6,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 500,
    pauseOnHover: true,
  };

  const history = useHistory();

  const modalCloseHandler = () => {
    setModalOpen(false);
  };

  const getDcGames = async () => {
    let response: AxiosResponse<DcGameNew[]>;
    if (loggedIn) {
      response = await SVLS_API.get('/catalog/v2/indian-casino/games', {
        headers: {
          Authorization: sessionStorage.getItem('jwt_token'),
        },
      });
    } else {
      response = await SVLS_API.get('/catalog/v2/indian-casino/games');
    }
    setGames(response.data);
  };

  const getGameUrl = async (gameInfo: string, gameName: string) => {
    if (loggedIn) {
      const gameId = parseInt(gameInfo.split(':')[0], 10);
      const gameCode = gameInfo.split(':')[1];
      const provider = gameInfo.split(':')[2];
      const subProvider = gameInfo.split(':')[3];
      if (provider === 'Indian Casino') {
        history.push(`/casino/indian/${gameCode}`);
      } else {
        history.push(
          `/dc/gamev1.1/${gameName.toLowerCase().replace(/\s+/g, '-')}-${btoa(
            gameId.toString()
          )}-${btoa(gameCode)}-${btoa(provider)}-${btoa(subProvider)}`
        );
        // redirectGame(gameId, gameCode, provider, subProvider);
      }
    } else {
      setShowDialog(true);
    }
  };
  useEffect(() => {
    fetchAllSectionsData();
  }, []);

  const fetchAllSectionsData = async () => {
    await Promise.all([
      fetchTrendingGames(),
      fetchLiveGames(),
      fetchVirtualGames(),
      fetchRoyalGames(),
    ]);
  };
  const fetchTrendingGames = async () => {
    let response: AxiosResponse<DcGameNew[]>;
    if (loggedIn) {
      response = await SVLS_API.get(
        'catalog/v2/categories/indian-casino/games/',
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
          params: {
            tag:'trending',
          },
        }
      );
    } else {
      response = await SVLS_API.get(
        'catalog/v2/categories/indian-casino/games/',
        {
          params: {
            tag:'trending',
          },
        }
      );
    }
    setTrendingGames(response.data);
  };
  const fetchLiveGames = async () => {
    let response: AxiosResponse<DcGameNew[]>;
    if (loggedIn) {
      response = await SVLS_API.get(
        'catalog/v2/categories/indian-casino/games/',
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
          params: {
            tag:'live_casino',
          },
        }
      );
    } else {
      response = await SVLS_API.get(
        'catalog/v2/categories/indian-casino/games/',
        {
          params: {
            tag:'live_casino',
            
          },
        }
      );
    }
    setLiveGames(response.data);
  };

  const fetchVirtualGames = async () => {
    let response: AxiosResponse<DcGameNew[]>;
    if (loggedIn) {
      response = await SVLS_API.get(
        'catalog/v2/categories/indian-casino/games/',
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
          params: {
           tag:'rg_virtuals',
          },
        }
      );
    } else {
      response = await SVLS_API.get(
        'catalog/v2/categories/indian-casino/games/',
        {
          params: { 
            tag:'rg_virtuals',
            
          },
        }
      );
    }
    setVirtualGames(response.data); 
  };

  const fetchRoyalGames = async () => {
    let response: AxiosResponse<DcGameNew[]>;
    if (loggedIn) {
      response = await SVLS_API.get(
        'catalog/v2/categories/indian-casino/games/',
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
          params: {
            tag:'royal_games',
            
          },
        }
      );
    } else {
      response = await SVLS_API.get(
        'catalog/v2/categories/indian-casino/games/',
        {
          params: {
            tag:'royal_games',
          },
        }
      );
    }

    setRoyalGames(response.data);
  };
  const getRoyalGamingUrl = async (
    gameId: string,
    gameName: string,
    gameCode: string,
    provider: string,
    subProvider: string,
  ) => {
    if (loggedIn) {
      if (provider === 'Indian Casino') {
        // setCasinoGame({ id: gameCode, name: gameName });
        history.push(`/casino/indian/${gameCode}`);
      } else {
        history.push(
          `/dc/gamev1.1/${gameName.toLowerCase().replace(/\s+/g, '-')}-${btoa(
            gameId.toString()
          )}-${btoa(gameCode)}-${btoa(provider)}-${btoa(subProvider)}`
        );
      }
    } else {
      setShowDialog(true);
    }
  };

  useEffect(() => {
    getDcGames();
  }, []);

  // useEffect(() => {
  //   if (games?.length > 0) {
  //     setLiveGames(
  //       games.filter(
  //         (game) =>
  //           game?.providerName === 'RG' &&
  //           game?.category?.toLocaleLowerCase() !== 'virtual'
  //       )
  //     );
  //     setVirtualGames(
  //       games.filter(
  //         (i) =>
  //           i?.providerName === 'RG' &&
  //           i?.category?.toLocaleLowerCase() === 'virtual'
  //       )
  //     );
  //   }
  // }, [games]);
  return (
    <>
      <SEO
        title={`${BRAND_NAME}`}
        description={'Home page description'}
        name="Home Page"
        type={'Bet on sports'}
        link={pathLocation?.pathname}
      />
      <div className="home-page">
        {domainConfig.isDomainConfigLoading ? (
          <div className="loading-div">
            <IonSpinner className="loading-page-spinner" name="bubbles" />
          </div>
        ) : (
          <div>
            <Banner allowedConfig={allowedConfig} />
            <IonGrid class="home-grid">
              {/* <Sports allowedConfig={allowedConfig} /> */}
              {checkForDomainConfig(
                CONFIG_PERMISSIONS.sports,
                showSportsComponents,
                showCasinoComponents
              ) ? (
                <SportsBook
                allowedConfig={allowedConfig} />
              ) : null}

              {showCasinoComponents ? <CasinoProvidersSlider /> : null}

              {checkForDomainConfig(
                CONFIG_PERMISSIONS.casino,
                showSportsComponents,
                showCasinoComponents
              ) ? (
                <>
                <GameCardsList
                  gameList={trendingGames}
                  getRoyalGamingUrl={getRoyalGamingUrl}
                  heading={Headings.trending}
                  subprovider ='CRASH88 Gaming'
                />
                <GameCardsList
                  gameList={royalGames}
                  getRoyalGamingUrl={getRoyalGamingUrl}
                  heading={Headings.royalGamingLive}
                   subprovider ='Royal Gaming'
                />
                  <GameCardsList
                    gameList={virtualGames}
                    getRoyalGamingUrl={getRoyalGamingUrl}
                    heading={Headings.royalGamingVirtual}
                    subprovider = 'Royal Gaming Virtual'
                  />
                  <GameCardsList
                    gameList={liveGames}
                    getRoyalGamingUrl={getGameUrl}
                    heading={Headings.liveGames}
                    subprovider ='Evolution Gaming'
                  />
                
                </>
              ) : null}

              {ShowPaymentMethods[BRAND_NAME.toLocaleLowerCase()] ? (
                <div className="sports-grid payment-methods-ctn">
                  <IonRow className="">
                    <IonCol size="12" class="sports-header">
                      <div>
                        <div className="sports-text">{Headings.payments}</div>
                      </div>
                    </IonCol>
                    <div className="payment-methods">
                      <div className="payment-method">
                        <img loading="lazy" src={GPAY} />
                      </div>
                      <div className="payment-method">
                        <img loading="lazy" src={PhonePe} />
                      </div>
                      <div className="payment-method">
                        <img loading="lazy" src={UPI} />
                      </div>
                      <div className="payment-method">
                        <img loading="lazy" src={BankTransfer} />
                      </div>
                      <div className="payment-method">
                        <img loading="lazy" src={PAYTM} />
                      </div>
                    </div>
                  </IonRow>
                </div>
              ) : null}
            </IonGrid>
          </div>
        )}

        <Modal
          open={modalOpen}
          title={modalTitle}
          closeHandler={modalCloseHandler}
          size="xs"
        >
          <LoginForm
            modalCloseHandler={modalCloseHandler}
            redirectUrl={redirectUrl}
          ></LoginForm>
        </Modal>
        <Dialog
          open={showDialog}
          onClose={() => setShowDialog(false)}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Notice</DialogTitle>
          <DialogContent>
            <div className="dc-dialog-body">
              You have to be logged in to play
            </div>
          </DialogContent>
          <DialogActions className="dc-dialog-actions">
            <Button
              onClick={() => setShowDialog(false)}
              color="primary"
              autoFocus
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </div>

      <Footer></Footer>
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    loggedIn: state.auth.loggedIn,
    allowedConfig: state.common.allowedConfig,
    domainConfig: state.common.domainConfig,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    casinoGameSelected: (game: { id: string; name: string }) =>
      dispatch(casinoGameSelected(game)),
    setDcGameUrl: (url: string) => dispatch(setDcGameUrl(url)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
